// BoardLayout.js

export const BOARD_LAYOUT_KANBAN = 'kanban';
export const BOARD_LAYOUT_LANES = 'lanes';

export const BOARD_LAYOUTS = Object.freeze([
  BOARD_LAYOUT_KANBAN,
  BOARD_LAYOUT_LANES,
]);

/**
 * Normalizes a Board layout value. Missing/invalid → kanban.
 *
 * @param {unknown} value
 * @returns {'kanban'|'lanes'}
 */
export function normalizeBoardLayout(value) {
  const normalized = String(value || '').trim().toLowerCase();
  return normalized === BOARD_LAYOUT_LANES ? BOARD_LAYOUT_LANES : BOARD_LAYOUT_KANBAN;
}
